const nextivaApps = [
  {
    title: 'CRM',
    subtitle: 'Case management',
    iconName: 'cases',
    accessible: true, // @TODO andrew remove from here
    serviceEndpoints: {
      actions: '/v1/services/actions',
      resources: '/v1/services/resources',
      settings: '/v1/services/settings',
    },
    scope: 'CRM',
    slug: 'CRM', // USE SCOPE INSTEAD!!!
    identName: 'crm',
  },
  {
    title: 'Platform Admin',
    subtitle: 'User management',
    iconName: 'tool',
    accessible: true, // @TODO andrew remove from here
    serviceEndpoints: {
      actions: '/platform-admin/v1/services/actions',
      resources: '/platform-admin/v1/services/resources',
      settings: '/platform-admin/v1/services/settings',
    },
    scope: 'PLATFORM_ADMIN',
    permissionsViewType: 'list',
    slug: 'PLATFORM_ADMIN',
  },
  {
    title: 'Data Migration Tool',
    subtitle: 'Data Migration',
    iconName: 'relationships',
    accessible: true, // @TODO andrew remove from here
    serviceEndpoints: {
      actions: '/data-migration/v1/services/actions',
      resources: '/data-migration/v1/services/resources',
      settings: '/data-migration/v1/services/settings',
    },
    scope: 'DM',
    slug: 'DM',
  },
  {
    title: 'Rules Engine',
    subtitle: 'Rules Engine',
    iconName: 'trigger',
    accessible: true, // @TODO andrew remove from here
    serviceEndpoints: {
      actions: '/rules-engine/services/actions',
      resources: '/rules-engine/services/resources',
      settings: '/rules-engine/services/settings',
    },
    scope: 'RULES_ENGINE',
    slug: 'RULES_ENGINE',
  },
  {
    title: 'Surveys',
    subtitle: 'Service questions',
    iconName: 'list',
    scope: 'Surveys',
    slug: 'Surveys',
    accessible: true, // @TODO andrew remove from here
    serviceEndpoints: {
      actions: '/surveys/v1/services/actions',
      resources: '/surveys/v1/services/resources',
      settings: '/surveys/v1/services/settings',
    },
  },
  {
    title: 'Dashboard',
    subtitle: 'Dashboard Builder',
    iconName: 'graph-line',
    scope: 'dashboard',
    slug: 'dashboard',
    permissionsViewType: 'list',
    accessible: true, // @TODO andrew remove from here
    serviceEndpoints: {
      actions: '/platform-dashboard/services/actions/',
      resources: '/platform-dashboard/services/resources/',
      settings: '/platform-dashboard/services/settings/',
    },
  },
  {
    title: 'Analytics',
    subtitle: 'Reporting',
    iconName: 'stats',
    scope: 'Analytics',
    slug: 'Analytics',
    accessible: true,
    serviceEndpoints: {
      actions: '/analytics/user_provision/actions',
      resources: '/analytics/user_provision/resources',
      settings: '/analytics/user_provision/settings',
    },
  },
  {
    title: 'Chat',
    subtitle: 'Service chat',
    iconName: 'buble-line',
    scope: 'chat',
    slug: 'chat',
    accessible: true,
    serviceEndpoints: {
      actions: '/chat/services/actions',
      resources: '/chat/services/resources',
      settings: '/chat/services/settings',
    },
  },
  {
    title: 'Voice',
    subtitle: 'Service calls',
    iconName: 'voice',
    scope: 'VOICE',
    slug: 'voice',
  },
  {
    title: 'Marketing',
    subtitle: 'Service emails',
    iconName: 'envelope-dot',
    scope: 'MARKETING',
    slug: 'marketing',
  },
];

export default nextivaApps;
